import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-eligibility-rules-dialog',
  templateUrl: './eligibility-rules-dialog.component.html',
  styleUrls: ['./eligibility-rules-dialog.component.scss']
})
export class EligibilityRulesDialogComponent {

  record: any;
  ruleStatuses: any[];

  constructor(
    public dialogRef: MatDialogRef<EligibilityRulesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.record = data.record;
    this.ruleStatuses = data.ruleStatuses || [];
  }

  getPassedRules() {
    return this.ruleStatuses.filter((r: any) => r.Passed);
  }

  getFailedRules() {
    return this.ruleStatuses.filter((r: any) => !r.Passed);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
